var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 18L18 18C22.9688 18 27 13.9688 27 9C27 4.03125 22.9688 -3.52423e-07 18 -7.86805e-07L9 -1.57361e-06C4.03125 -2.00799e-06 1.48346e-06 4.03125 1.04907e-06 9C6.14691e-07 13.9687 4.03125 18 9 18ZM9 2.25C12.75 2.25 15.75 5.25 15.75 9C15.75 12.7031 12.75 15.75 9 15.75C5.29688 15.75 2.25 12.7031 2.25 9C2.25 5.25 5.29688 2.25 9 2.25Z",
    fill: "#2B3A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggleOff.62a6e2da.svg";
export { ForwardRef as ReactComponent };